import { BylineProps } from 'components/Article/Byline/Byline.types'
import OuvirMateriaButton from 'components/Buttons/OuvirMateriaButton'
import { useIcon } from 'hooks/useIcon'

const BylineRightSectionComponent = () => {
  return (
    <OuvirMateriaButton
      icon={{ ...useIcon('IcPlayAudioMateriaAzul') }}
      onClick={(e) => console.log('play audio materia', e)}
    />
  )
}

const bylineProps: BylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true,
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)',
    }
  },
  customCssContent: {
    ml: '$3',
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px',
    }
  },
  publishedDate: {
    enabled: true,
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '23px'
      }
    }
  },
  rightSlot: {
    children: <BylineRightSectionComponent/>
  }
}

export const article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px',
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '24px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '$secondaryMain',
      }
    }
  },
  titleProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'p',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [
      {
        id: 'facebookShare',
        alt: 'Compartilhar no Facebook',
        icon: 'IcBotaoFacebook',
        href: 'https://www.facebook.com/sharer/sharer.php?u='
      },
      {
        id: 'twitterShare',
        alt: 'Compartilhar no Twitter',
        icon: 'IcBotaoTwitter',
        href: 'https://twitter.com/intent/tweet?text='
      },
      {
        id: 'whatsappShare',
        alt: 'Compartilhar no WhatsApp',
        icon: 'IcBotaoWhatsApp',
        href: 'https://api.whatsapp.com/send?text='
      }
    ]
  }
}
